// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__3W6Q6"};